module.exports = __webpack_public_path__ + "index.sandglass-time-loading-gif.gif?5ce55b094aa8de721c915600db40b710";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.sandglass-time-loading-gif.gif
// module id = 8
// module chunks = 0